import React, { useState, useEffect,useRef  } from 'react';

import axios from 'axios';
import './Footer.css'; // Import the CSS for styling
import { FaFacebookF } from "react-icons/fa";
import { IoCall } from "react-icons/io5";
import { FaYoutube } from "react-icons/fa";
import { NavLink } from 'react-router-dom';

const Footer = () => {
  const [locationUrl, setLocationUrl] = useState('');
  const [address, setAddress] = useState('');
  const [loading, setLoading] = useState(false);const [message, setMessage] = useState('');
// Fetch existing data
useEffect(() => {
  const fetchLocationData = async () => {
      try {
          const response = await axios.get('https://zoomautos.co.uk/api/LogisticsLocation', {
           
          params: {
            _t: new Date().getTime(), // Add timestamp to bypass cache
          },
        
        });
          setLocationUrl(response.data.locationUrl || '');
          setAddress(response.data.address || '');
      } catch (error) {
          console.error('Error fetching location data:', error);
      }
  };
  fetchLocationData();
}, []);
const [contactNo, setContactNo] = useState('');
  
    // Fetch the contact number on component mount
    useEffect(() => {
      const fetchContact = async () => {
        try {
          setLoading(true);
          const response = await axios.get('https://zoomautos.co.uk/api/LogisticsContact', {
            
          params: {
            _t: new Date().getTime(), // Add timestamp to bypass cache
          },
        
        });
          setContactNo(response.data.contactNo || '');
          setLoading(false);
        } catch (error) {
          setLoading(false);
          setMessage('Error fetching contact number');
        }
      };
      fetchContact();
    }, []);
    const [email,setEmail]=useState('')
    useEffect(() => {
      const fetchEmailData = async () => {
          try {
              const response = await axios.get('https://zoomautos.co.uk/api/LogisticsEmail',{
                
              params: {
                _t: new Date().getTime(), // Add timestamp to bypass cache
              },
            
            });
              setEmail(response.data.email || '');
          } catch (error) {
              console.error('Error fetching email data:', error);
          }
      };
      fetchEmailData();
  }, []);
  

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Quick Links */}
        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li>
              <NavLink 
                to="/" 
                className={({ isActive }) => (isActive ? 'active-link' : 'link')}
              >
                Home
              </NavLink>
            </li>
            {/* <li>
              <NavLink 
                to="/move" 
                className={({ isActive }) => (isActive ? 'active-link' : 'link')}
              >
                Move
              </NavLink>
            </li> */}
            <li>
              <NavLink 
                to="/subcontractform" 
                className={({ isActive }) => (isActive ? 'active-link' : 'link')}
              >
                Get A Quote
              </NavLink>
            </li>
            
            <li>
              <NavLink 
                to="/DriveDetail" 
                className={({ isActive }) => (isActive ? 'active-link' : 'link')}
              >
                Drive For Us
              </NavLink>
              </li>
            
              <li>
              <NavLink 
                to="/services" 
                className={({ isActive }) => (isActive ? 'active-link' : 'link')}
              >
                Our Services
              </NavLink>
            </li>
            <li>
              <NavLink 
                to="/LogisticContact" 
                className={({ isActive }) => (isActive ? 'active-link' : 'link')}
              >
                Contact Us
              </NavLink>
            </li>
              <li>
              <NavLink 
           
              to="/Termsandconditions"
              className={({ isActive }) => (isActive ? 'active-link' : 'link')}
              >
                Terms and Conditions
              </NavLink>
              
            </li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-section">
          <h4>Contact Us</h4>
          <p>
            Address:  
            <a 
             href={locationUrl} 
              className="link" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              {address}
            </a>
          </p>
          <p>
            Phone: 
            <a href="tel:${contactNo}" className="link">
              {contactNo}
            </a>
          </p>
        </div>

        {/* Social Media Icons */}
        <div className="footer-section">
          <h4>Follow Us</h4>
          <div className="social-icons">
            
            <a 
              href="tel:${contactNo}" 
              
              aria-label="Call Us"
            >
              <IoCall />
            </a>
          </div>
          <h4>Email Us</h4>
          <p>
            <a href="mailto:${email}" className="link">
              {email}
            </a>
          </p>
        </div>
      </div>

      {/* Copyright */}
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Zoom Autos. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
